
import { OfficeProfileDto, OfficeStatusFormDto, OfficeDataDto } from "@/types/office.type";
import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import OfficeProfileMixin from "../office-profiles.mixin";
import { format as formatPhone } from "@/utils/phone.util";
import moment from "moment";
import { DayOfWeek } from "@/types/enums.type";
import { StatusNames, SubscriptionStatus } from "@/common/constants";
import AuthMixin from "@/common/mixins/auth.mixin";

@Component({
  computed: {
    ...mapState("OfficeProfile", ["officeData"])
  }
})
export default class OfficeProfileCardComponent extends Mixins(OfficeProfileMixin, AuthMixin) {
  @Prop() office!: OfficeProfileDto;
  @Prop() color!: string;
  
  officeData!: OfficeDataDto;

  isCollapsed = false;

  DayOfWeek = DayOfWeek;
  formatPhone = formatPhone;
  StatusNames = StatusNames;

  get subscriptionStatus(): string | undefined {
    const noCardText = this.officeData.subscriptionStatuses.find(status => status.identifier === SubscriptionStatus.TrialingEnded.value)?.text;
    const statusText = this.officeData.subscriptionStatuses.find(status => status.value === this.office.subscriptionStatus)?.text;

    if (!this.office.isBillable) {
      return SubscriptionStatus.Active.value;
    }

    if (this.office.isSubscriptionCancelled) {
      return "Cancelled";
    }

    if (this.office.disabled) {
      return "Disabled";
    }

    return statusText ?? noCardText;
  }

  get backgroundStyle(): string {
    return `background: ${this.color};`;
  }

  getTime(time: string): string {
    return moment(time, 'HH:mm').format("hh:mm A")
  }

  toEdit(toPayment: boolean = false): void {
    this.$store.commit("OfficeProfile/updateField", {
      path: "selectedOffice",
      value: this.office
    });

    this.$store.commit("OfficeProfile/updateField", {
      path: "isEdit",
      value: true
    });

    if (toPayment) {
      this.$router.push({ path: "/office-profiles-edit", query: { activeTab: "5" } });
    }
    else {
      this.$router.push("/office-profiles-edit");
    }
  }

  async onStatusChange(value: boolean): Promise<void> {
    this.setLoading(true);

    let statusId = StatusNames.Disabled.getId(this.officeData.statuses);

    if (!value) {
      statusId = StatusNames.Enabled.getId(this.officeData.statuses);
    }

    await this.$store.dispatch("OfficeProfile/updateOfficeStatus", {
      id: this.office.id,
      statusId
    } as OfficeStatusFormDto);
    await this.$store.dispatch("OfficeProfile/getOfficeProfiles", this.userInfo()?.practiceId);
  
    this.setLoading(false);
  }
}
